(() => {
    const root = document.querySelector('.tck');
    if (!root) return;

    const dataEl = root.querySelector('#tck-products');
    const products = (dataEl ? JSON.parse(dataEl.textContent) : []).map(enrich);
    const settings = {
    cartAdd: root.dataset.cartAdd || '/cart/add',
    cart: root.dataset.cart || '/cart',
    pinOuterwear: root.dataset.pinOuterwear || ''
    };
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Brand and category come from the product title, since every product's vendor is "TCK"
    function enrich(p) {
    const t = p.t.trim().replace(/\.+$/, '');
    const tl = t.toLowerCase();
    const b = /^saucony/.test(tl) ? 'Saucony'
    : /^trailberg/.test(tl) ? 'Trailberg'
    : /^under armour/.test(tl) ? 'Under Armour'
    : /^montane/.test(tl) ? 'Montane'
    : /^berghaus/.test(tl) ? 'Berghaus'
    : 'TCK';
    const c = /\bcaps?\b/.test(tl) ? 'caps'
    : /saucony|slider|trainer|runner/.test(tl) ? 'footwear'
    : /\bset\b|tracksuit|twinset/.test(tl) ? 'sets'
    : /shorts/.test(tl) ? 'shorts'
    : /jacket|windbreaker|hoodie|zip|fleece|coat/.test(tl) ? 'outerwear'
    : 'tops';
    return { ...p, t, b, c };
    }

    // Announcement bar
    const notices = [...root.querySelectorAll('.tck-notice-msg')];
    let noticeIdx = 0;
    if (!reduceMotion && notices.length > 1) {
    setInterval(() => {
    notices[noticeIdx].classList.remove('tck-active');
    noticeIdx = (noticeIdx + 1) % notices.length;
    notices[noticeIdx].classList.add('tck-active');
    }, 4500);
    }

    // Hero slideshow
    const hero = root.querySelector('.tck-hero');
    if (hero) {
    const slides = [...hero.querySelectorAll('.tck-slide')];
    const dots = [...hero.querySelectorAll('.tck-dots button')];
    let current = 0, timer;
    const schedule = () => {
    clearTimeout(timer);
    if (!reduceMotion) timer = setTimeout(() => show(current + 1), 7000);
    };
    const show = (i) => {
    current = (i + slides.length) % slides.length;
    slides.forEach((s, n) => s.classList.toggle('tck-active', n === current));
    dots.forEach((d, n) => d.setAttribute('aria-current', n === current));
    // restart the progress line
    hero.classList.remove('tck-playing'); void hero.offsetWidth; hero.classList.add('tck-playing');
    schedule();
    };
    dots.forEach((d, n) => d.addEventListener('click', () => show(n)));
    schedule();
    }

    // ---------- Product cards ----------
    const NEW_DAYS = 30;
    const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const money = n => '£' + (Number.isInteger(n) ? n : n.toFixed(2));
    const titleCase = s => s.replace(/\b([a-z])/g, (m, c, i) => (i && /^and\b/.test(s.slice(i)) ? c : c.toUpperCase()));
    const isNew = p => (Date.now() / 1000 - p.at) / 86400 <= NEW_DAYS;
    const inStock = p => p.sz.length ? p.sz.some(s => s.ok) : p.ok;
    const sizesLeft = p => {
    const n = p.sz.filter(s => s.ok).length;
    return n ? ` · ${n} ${n === 1 ? 'size' : 'sizes'} left` : '';
    };

    function card(p) {
    const off = p.was ? Math.round((1 - p.p / p.was) * 100) : 0;
    const soldOut = !inStock(p);
    const name = esc(titleCase(p.t));
    const tag = `<span class="tck-tags">${soldOut ? '<span class="tck-tag">Sold out</span>'
    : (isNew(p) ? '<span class="tck-tag tck-tag-new">New</span>' : '') + (off ? `<span class="tck-tag tck-tag-sale">${off}% off</span>` : '')}</span>`;
    const alt = p.img[1] ? `<img class="tck-alt" src="${esc(p.img[1])}" alt="" loading="lazy">` : '';

    let quick = '';
    if (!soldOut) {
    quick = p.sz.length
    ? `<div class="tck-quick-add"><span>Quick add</span><div class="tck-sizes">${p.sz.map(s => s.ok
    ? `<button type="button" data-variant="${s.id}" aria-label="Add ${name}, size ${esc(s.s)}, to bag">${esc(s.s)}</button>`
    : `<span class="tck-size-out" aria-label="Size ${esc(s.s)} sold out">${esc(s.s)}</span>`).join('')}</div></div>`
    : `<div class="tck-quick-add"><button type="button" class="tck-add-one" data-variant="${p.v}">Add to bag</button></div>`;
    }

    return `<article class="tck-product${soldOut ? ' tck-is-out' : ''}">
    <div class="tck-product-media">
    <a href="${esc(p.url)}" tabindex="-1" aria-hidden="true">
    ${tag}
    <img src="${esc(p.img[0] || '')}" alt="${name}" loading="lazy">${alt}
    </a>
    ${quick}
    </div>
    <div class="tck-product-info">
    <h3 class="tck-product-name"><a href="${esc(p.url)}">${name}</a></h3>
    <span class="tck-product-price">${money(p.p)}${p.was ? ` <s>${money(p.was)}</s>` : ''}</span>
    <span class="tck-product-colour">${esc(p.b)}${sizesLeft(p)}</span>
    </div>
    </article>`;
    }
    
    // Quick add: put the size in the real Shopify bag, then go to the bag
    root.addEventListener('click', async e => {
    const btn = e.target.closest('.tck-quick-add [data-variant]');
    if (!btn) return;
    const box = btn.closest('.tck-quick-add');
    box.querySelector('.tck-quick-add-msg')?.remove();
    btn.setAttribute('aria-busy', 'true');
    try {
    const res = await fetch(`${settings.cartAdd}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] })
    });
    if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.description || 'That size could not be added. Try again.');
    }
    window.location.href = settings.cart;
    } catch (err) {
    btn.removeAttribute('aria-busy');
    box.insertAdjacentHTML('beforeend', `<span class="tck-quick-add-msg" role="alert">${esc(err.message)}</span>`);
    }
    });

    // Caps always go last so shoes and clothes lead
    const capsLast = (a, b) => (a.c === 'caps') - (b.c === 'caps');
    const byNewest = (a, b) => b.at - a.at;

    // New in rail: newest shoes and clothes first, caps at the end
    const rail = root.querySelector('#tck-new-rail');
    if (rail) {
    rail.innerHTML = products.filter(inStock).sort((a, b) => capsLast(a, b) || byNewest(a, b)).slice(0, 10).map(card).join('');
    root.querySelectorAll('.tck-rail-btn').forEach(btn => btn.addEventListener('click', () => {
    const step = rail.clientWidth * 0.8 * Number(btn.dataset.dir);
    rail.scrollBy({ left: step, behavior: reduceMotion ? 'auto' : 'smooth' });
    }));
    }

    // Full range: tabs + brand filter + show more
    const grid = root.querySelector('#tck-range-grid');
    if (!grid) return;
    const PAGE = 12;
    const tabs = [...root.querySelectorAll('.tck-tabs [role=tab]')];
    const moreBtn = root.querySelector('.tck-more-btn');
    const countEl = root.querySelector('.tck-range-count');
    const brandNote = root.querySelector('.tck-brand-filter');
    const state = { filter: 'all', brand: null, shown: PAGE };

    // Product shown first when a category tab is open
    const PINNED = { outerwear: settings.pinOuterwear };

    // caps last, then in-stock first, then newest
    const ranked = [...products].sort((a, b) => capsLast(a, b) || (inStock(b) - inStock(a)) || byNewest(a, b));

    function renderRange() {
    const pin = PINNED[state.filter];
    const list = ranked.filter(p =>
    (state.filter === 'all' || p.c === state.filter) &&
    (!state.brand || p.b === state.brand))
    .sort((a, b) => (b.h === pin) - (a.h === pin));
    grid.innerHTML = list.slice(0, state.shown).map(card).join('');
    countEl.textContent = `${list.length} ${list.length === 1 ? 'item' : 'items'}`;
    moreBtn.hidden = list.length <= state.shown;
    tabs.forEach(t => t.setAttribute('aria-selected', t.dataset.filter === state.filter));
    brandNote.hidden = !state.brand;
    if (state.brand) brandNote.querySelector('strong').textContent = state.brand;
    }
    tabs.forEach(t => t.addEventListener('click', () => {
    state.filter = t.dataset.filter; state.shown = PAGE; renderRange();
    }));
    moreBtn.addEventListener('click', () => { state.shown += PAGE; renderRange(); });
    brandNote.querySelector('button').addEventListener('click', () => { state.brand = null; renderRange(); });

    // Any link in the section can jump to a filtered view of the range
    root.querySelectorAll('[data-jump], [data-brand]').forEach(a => a.addEventListener('click', () => {
    state.filter = a.dataset.jump || 'all';
    state.brand = a.dataset.brand || null;
    state.shown = PAGE;
    renderRange();
    }));
    renderRange();

    // Newsletter: check the email before it posts to Shopify
    const form = root.querySelector('.tck-signup form');
    const msg = root.querySelector('.tck-signup-msg');
    form?.addEventListener('submit', e => {
    const email = form.querySelector('input[type=email]');
    if (!email.value || !email.checkValidity()) {
    e.preventDefault();
    msg.textContent = 'Enter a valid email address, like name@example.com.';
    email.focus();
    }
    });
    })();
